import { render, staticRenderFns } from "./ServiceCatalogPage.vue?vue&type=template&id=3c13cc2c&scoped=true&"
import script from "./ServiceCatalogPage.vue?vue&type=script&lang=js&"
export * from "./ServiceCatalogPage.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCatalogPage.vue?vue&type=style&index=0&id=3c13cc2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c13cc2c",
  null
  
)

export default component.exports